<template>
    <section class="benefits-section py-5">
        <div class="container">
            <div class="text-center mb-5">
                <h2 class="section-title">Korzyści ze współpracy</h2>
                <p class="section-subtitle">Dlaczego warto wybrać nasze biuro rachunkowe?</p>
            </div>

            <div class="row">
                <div class="col-lg-6 mb-4">
                    <div class="benefit-item d-flex">
                        <div class="benefit-icon me-3">
                            <i class="fas fa-clock fa-2x text-success"></i>
                        </div>
                        <div class="benefit-content">
                            <h4>Oszczędność czasu</h4>
                            <p>Przedsiębiorca może skupić się na prowadzeniu biznesu, zamiast zajmować się
                                formalnościami księgowymi.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mb-4">
                    <div class="benefit-item d-flex">
                        <div class="benefit-icon me-3">
                            <i class="fas fa-shield-alt fa-2x text-success"></i>
                        </div>
                        <div class="benefit-content">
                            <h4>Minimalizacja ryzyka błędów</h4>
                            <p>Nasi księgowi dbają o poprawność dokumentacji i zgodność z przepisami.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mb-4">
                    <div class="benefit-item d-flex">
                        <div class="benefit-icon me-3">
                            <i class="fas fa-balance-scale fa-2x text-success"></i>
                        </div>
                        <div class="benefit-content">
                            <h4>Bezpieczeństwo i aktualność przepisów</h4>
                            <p>Na bieżąco śledzimy zmiany w prawie podatkowym i dostosowujemy do nich sposób rozliczeń
                                klientów.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 mb-4">
                    <div class="benefit-item d-flex">
                        <div class="benefit-icon me-3">
                            <i class="fas fa-piggy-bank fa-2x text-success"></i>
                        </div>
                        <div class="benefit-content">
                            <h4>Optymalizacja kosztów</h4>
                            <p>Profesjonalne doradztwo pomoże w zmniejszeniu obciążeń podatkowych w granicach
                                obowiązującego prawa.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BenefitsSection'
}
</script>

<style lang="scss" scoped>
.benefits-section {
    .section-title {
        color: var(--primary-color);
        margin-bottom: 1rem;
    }

    .section-subtitle {
        color: #6c757d;
        max-width: 600px;
        margin: 0 auto;
    }

    .benefit-item {
        padding: 1.5rem;
        border-radius: 8px;
        background-color: white;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
        height: 100%;
        transition: transform 0.3s ease;

        &:hover {
            transform: translateY(-5px);
        }

        .benefit-icon {
            flex-shrink: 0;
        }

        h4 {
            color: var(--primary-color);
            font-size: 1.2rem;
            margin-bottom: 0.7rem;
        }

        p {
            color: #6c757d;
            margin-bottom: 0;
        }
    }
}
</style>